module.exports = __webpack_public_path__ + "static/media/shaan.40bb0b17.jpeg";